module.exports = __webpack_public_path__ + "static/img/katun03.600ed5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/katun03.jpg
// module id = K3B/
// module chunks = 0